import React, { Component } from 'react';
import 'ant-design-pro/dist/ant-design-pro.css';


import createHistory from 'history/createHashHistory'
import $ from "jquery"
import EventSet from "./../../../assets/PubJs/hcPub"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import "./LoginEntry.css"
import logo from "./../../../assets/images/loginLogo.png"


import { Form, Icon, Input, Button, Checkbox, Alert,Tabs, message,Row,Col,Modal,Popover,Progress } from 'antd';

const { TabPane } = Tabs;
const FormItem = Form.Item;
const confirm = Modal.confirm;

const history = createHistory();
function reloadcode(o) {
  o.src = Hcurl + "/user/GetCompanyCode?t=" + Math.random();
}
let base = new EventSet.Base64();
let time = null;

//点击修改密码的弹窗
let _PasswordRevise = null;
class PasswordRevise extends React.Component {
    state = {
        confirmDirty: false,
        modelTitel:'密码修改',
        visible:false,
        level: '弱',
        proColor: '#f5222d',
        source: 10,
        sourceText: '8-16位，须同时包含字母、数字、符号，区分大小写，请不要使用容易被猜到的密码。',
        visibleP: false,
    };

    componentDidMount() {
        _PasswordRevise = this;
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }
    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('两次输入的密码不匹配！');
        } else {
            callback();
        }
    }



    FirstPassword(rule, value, callback) {
        console.log('894',value)
        if(!value)
        {
          callback()
          _PasswordRevise.setState({
            visibleP: false,
          })
        }
        else if(/^.*[\u4E00-\u9FA5].*$/.test(value))
        {
          callback('密码中不可包含中文')
        }
        else
        {
          _PasswordRevise.setState({
            visibleP: false,
          })
          if(value.indexOf(' ')>-1){
            callback('密码中不可包含空格');
          }
          else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)(?![\W]+$)(?![0-9a-zA-Z]+$)(?![0-9a-z\W]+$)(?![0-9\W]+$)(?![a-zA-Z\W]+$)[0-9A-Za-z\W]{8,16}$/.test(value)) {
            callback('8-16位，须同时包含字母、数字、符号，区分大小写。');
          } 
          else {
           
            if(EventSet.returnScore(value) < 60)
            {
              callback('密码太简单了，请重新设置。');
            }
            else if(sessionStorage.getItem('codeData') && sessionStorage.getItem('codeData').split('臡').indexOf(value)>-1)
            {
              callback('密码太简单了，请重新设置。');
              _PasswordRevise.setState({
                proColor:'#f5222d',
                level:'弱',
                source:33
                })
            }
            // else if(value == 'Welcome.1')
            // {
            //     console.log('1072')
            //   callback('不可以设置为初始密码');
            // }
            else
            {
              _PasswordRevise.setState({
                visibleP:true,
            })
            if(EventSet.returnScore(value)<60){
                _PasswordRevise.setState({
                    proColor:'#f5222d',
                    level:'弱',
                    source:33
                })
            }else if (EventSet.returnScore(value)>59&&EventSet.returnScore(value)<80){
                _PasswordRevise.setState({
                    proColor:'orange',
                    level:'中',
                    source:66
                })
            }else{
                _PasswordRevise.setState({
                    proColor:'#52c41a',
                    level:'强',
                    source:99
                })
            }
              callback();
            }
          }
        }
      };
      blur=()=>{
        _PasswordRevise.setState({
          visibleP:false,
           
        })
      }
  //密码修改弹窗确定
    handleOk = (e) => {
        console.log('275')
        _PasswordRevise.props.form.validateFields((err, values) => {
            console.log('277',err)
            if (!err) {
              _PasswordRevise.setState({
                visibleP:false,
            })
                let postData = {
                  passWord: _PasswordRevise.props.form.getFieldValue("username"),
                  newPassWord: _PasswordRevise.props.form.getFieldValue("password"),
                  CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
                }
                $.ajax({
                    url: Hcurl + "/user/UpdatePassword",
                    type: "post",
                    data: postData,
                    headers: {
                      "token": EventSet.getUserInfo()['token']
                      },
                    async: false,
                    success: function (res) {
                      var data = res
                        if(data.indexOf('false')>-1){
                          _PasswordRevise.setState({
                            visibleP:false,
                        });
                          message.warn(data.split('|')[1])
                        } else {
                            message.success("密码修改成功");
        
                            //弹窗消失
                            _PasswordRevise.setState({
                                visible: false,
                                visibleP:false,
                            });
        
                            setTimeout(() => {
                                window.location.reload()
                            }, 100);
        
                        }
                    }
                })
                // const data = http.ajax({
                //     url: 'ComHomePage/UpdateComPassword',
                //     data: postData,
                //     type:'post'
                // })
              
            }else{
              _PasswordRevise.setState({
                visibleP:false,
            })
            }
        })
    }
    //密码修改弹窗取消
    handleCancel = (e) => {
        _PasswordRevise.props.form.resetFields()
        this.setState({
            visible: false,
            visibleP:false,
        });
    }
    blur=()=>{
      _PasswordRevise.setState({
        visibleP:false,
         
      })
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };
        return (
            <Modal
            title={this.state.modelTitel}
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            okText="确定"
            cancelText="取消"
            maskClosable={false}
        >
            <Form style={{ width: 500, margin: "0 auto" }}>
                <FormItem
                    {...formItemLayout}
                    label="原密码"
                >
                    {getFieldDecorator('username', {
                        rules: [{
                            required: true, message: '请输入原密码！',
                        }, {
                            validator: this.userTest,
                        }],
                    })(
                        <Input type="password" placeholder="请输入原密码" />
                        )}
                </FormItem>
                <Popover
                      placement="rightTop"
                      content={<div style={{ width: '290px', padding: '10px 10px' }}>
                          <p style={{ color: this.state.proColor, marginBottom: '0' }}>强度：{this.state.level}</p>
                          <Progress strokeColor={this.state.proColor} percent={this.state.source} showInfo={false} />
                          <p style={{ marginBottom: '0' }}>{this.state.sourceText}</p>
                      </div>}
                      title="密码强度"
                      trigger="click"
                      visible={this.state.visibleP}
                  >
                      <div ></div>
                </Popover>
                <FormItem
                    {...formItemLayout}
                    label="新密码"
                >
                    {getFieldDecorator('password', {
                        rules: [{
                            required: true, message: '请输入新密码！',
                        }, { validator: this.FirstPassword }],
                    })(
                      <Input onBlur={this.blur} type="password" placeholder="8-16位字母、数字、符号的组合，区分大小写" maxLength="16" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="确认密码"
                >
                    {getFieldDecorator('confirm', {
                        rules: [{
                            required: true, message: '请确认密码！',
                        }, {
                            validator: this.compareToFirstPassword,
                        }],
                    })(
                        <Input type="password" onBlur={this.handleConfirmBlur} placeholder="确认密码" maxLength="16" />
                        )}
                </FormItem>
            </Form>
            </Modal>
        );
    }
}

const PasswordModal = Form.create()(PasswordRevise);



var timerY = null
let _LoginModule = null;
class LoginModule extends React.Component {
  state = {
    alertShow: "",
    loading: false,
    messageWarn: "",
    UserIp: "",
    UserChecked: false,
    captcha: "获取验证码",
    captDisable: true,
    phoneExist: false,
    loading: false,
    userFormat: false,
    phoneFormat:false,
    tabkey:'1',  
    ImageSrc: '',
    titleText:'为了您的账户安全，请及时修改密码',
    title:'',
  }
  componentDidMount() {
    _LoginModule = this;
    //是否记住用户名
    if (localStorage.getItem("username") != undefined && localStorage.getItem("username") != "" && localStorage.getItem("username") != null) {
      let userName = localStorage.getItem("username");
      _LoginModule.props.form.setFieldsValue({
        userName: userName
      })
    }

    if (localStorage.getItem("rememberUser") != null && localStorage.getItem("rememberUser") == "true") {
      _LoginModule.props.form.setFieldsValue({
        remember: true
      })
      this.setState({
        UserChecked: true
      })
    } else {
      _LoginModule.props.form.setFieldsValue({
        remember: false
      })
      this.setState({
        UserChecked: false
      })
    }
    this.onRefres()
    this.getpass()
    this.getCode()
  }
  getpass=()=>{
    $.ajax({
      url: Hcurl + "/user/GetWeakLib",
      type: "get",
      async: false,
      success: function (res) {
        // console.log(res)
        sessionStorage.setItem('codeData', res)
      }})
  }
  getCode=()=>{
    $.ajax({
      url: Hcurl + "/user/GetCompanyCode",
      type: "get",
      async: false,
      success: function (res) {
        clearTimeout(timerY);
        timerY = null;
        timerY = setTimeout(() => {
          _LoginModule.getCode();
        }, 300000);
        _LoginModule.setState({
          ImageSrc:'data:image/png;base64,'+JSON.parse(res).Data.imgBase64,
          mark:JSON.parse(res).Data.mark
        })
      }})
  }
  //刷新验证码
  onRefres = () => {
    this.getCode()
    // reloadcode(document.getElementById('img'));
  }
  onMessageSend = (record) => {
    let _this = this
    confirm({
        title:_LoginModule.state.titleText ,
        content: _LoginModule.state.title,
        cancelText:'取消',
        okText:'立即修改',
        onOk() {
            _PasswordRevise.setState({
                visible:true
            })
        },
        onCancel() { 
            _LoginModule.onRefres()
        },
    });
};
  //提交
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      //console.log(values)
      if (!err) {
                 //登录
            $.ajax({
              url: Hcurl + "/user/Login",
              type: "post",
              data: {
                userName: values.userName,
                password: values.password,
                validCode:values.yzm,
                Explore:EventSet.myBrowser(),
                SystemName:EventSet.browserRedirect(),
                PicValidName:_LoginModule.state.mark
              },
              async: false,
              success: function (res) {
                let userInfo = JSON.parse(res);
                console.log(userInfo.Info)
                _LoginModule.setState({
                  loading: false
                })
                // _LoginModule.onMessageSend()
                if (userInfo.msg.indexOf("false") >= 0) {
                  _LoginModule.onRefres()
                  //警告提示词
                  if (userInfo.msg.split("|")[1] != undefined) {
                    _LoginModule.setState({
                      messageWarn: userInfo.msg.split("|")[1]
                    })
                  } else {
                    _LoginModule.setState({
                      messageWarn: "用户名或密码错误"
                    })
                  }


                  setTimeout(function () {
                    _LoginModule.setState({
                      alertShow: <Alert message={_LoginModule.state.messageWarn} type="error" showIcon closable onClose={_LoginModule.onClose} />
                    })
                  }, 50)

                } else {
                  if (values.remember) {
                    localStorage.setItem("username", values.userName)
                    localStorage.setItem("rememberUser", "true");
                  } else {
                    localStorage.removeItem("username")
                    localStorage.setItem("rememberUser", "false");
                  }
                  localStorage.setItem("userInfo", res);
                  var info=JSON.parse(res)['Info'];
                  sessionStorage.setItem('pwdInfo',info);
                  $.ajax({
                    url: Hcurl + "/CompanyCore/GetSelectCompany",
                    type: "post",
                    data: {
                      UserCode: userInfo.CU_Code
                    },
                    headers: {
                      "token": userInfo.token
                    },
                    success: function (res) {
                      if (res != null) {
                        res = JSON.parse(res);
                      }
                        //   _LoginModule.setState({
                      //       title:info
                      //   })
                      if(userInfo.Info=='1'){
                        message.success("登陆成功");
                        if (res.length == 0 || res == null || res == undefined || res == "") {
                          history.push({ pathname: '/Content/Business/CompanyList', })
                        } else {
                          history.push({ pathname: '/Content/Home', })
                        }
                      }else if(userInfo.Info=='2'){
                        _LoginModule.setState({
                          title:'您的密码复杂度太低（密码中必须包含字母、数字和特殊字符），请及时修改密码。',
                        })
                        _LoginModule.onMessageSend()
                       
                      
                      }else if(userInfo.Info=='3'){
                        history.push({ pathname: '/Login/LoginMain/LoginInfo', })
                      }
                      else if(userInfo.Info=='4'){
                        _LoginModule.setState({
                          title:'您的密码已过期，请及时修改密码。',
                        })
                        _LoginModule.onMessageSend()

                      }
                      else if(userInfo.Info=='5'){
                        _LoginModule.setState({
                          title:'您的密码为初始密码，请及时修改密码。',
                        })
                        _LoginModule.onMessageSend()
                      

                      }


                    },
                    error: function () {
                        //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    }
                  })
                }
              },
              error: function () {
                 
              }
            })
      
           
    
 
      }
    });
  }
  //获取验证码
  getCaptcha = () => {
    var _this=this;
    if (!_this.state.phoneExist) {
        //发送验证码
        let num = "";
        for (var i = 0; i < 5; i++) {
            num += Math.floor(Math.random() * 10)
        }

        
        $.ajax({
          // url: "https://webservice.jshcsoft.com/SSMSAPI/encryssms.ashx",
          url: Hcurl + "/HomePage/SendValidCode?phone=" + _this.props.form.getFieldValue('phone')+"&type=2",
          type: "get",

          async: false,
          success: function (res) {
            console.log(res)
                if (res.indexOf("true") >= 0) {
                    message.success("验证码发送成功");
                    localStorage.setItem("captchaPhoneNum", _this.props.form.getFieldValue("phone"))

                    _this.setState({
                        captcha: "60s",
                        captDisable: "true"
                    }, () => {
                        var timer = 60;
                        time = setInterval(function () {
                            timer--;
                            _this.setState({
                                captcha: timer + "s"
                            }, () => {
                                if (timer == 0) {
                                    window.clearInterval(time);
                                    time = null;
                                    _this.setState({
                                        captcha: "获取验证码",
                                        captDisable: ""
                                    })
                                }
                            })
                        }, 1000)
                    })
                } else {
                    message.error("验证码发送失败");
                }
            }
        })
    }
  }
  //失去焦点判断手机号是否存在
  phoneTest = () => {
    var _this=this;

  }

  //注册
  register = () => {
    history.push({ pathname: '/Login/LoginMain/Register', })
  }

  //信息完善
  loginInfo = () => {
    history.push({ pathname: '/Login/LoginMain/LoginInfo', })
  }

  //下载手册
  operation = () => {
    window.open(pdfUrl)
  }

  //忘记密码
  forgetPassword = () => {
    history.push({ pathname: '/Login/LoginMain/LoginForget', })
  }

  //账号密码错误关闭
  onClose = () => {
    _LoginModule.setState({
      alertShow: null
    })
  }

  UserChange = (e) => {
    this.setState({
      UserChecked: e.target.checked,
    });
  }
  //验证手机号格式
  phoneInputTest = (rule, value, callback) => {
    var _this=this;
    if (value != undefined && value != "" && value != null) {
        let reg = /^1[0-9]{10}$/;
        if (reg.test(value) == false) {
            callback("手机号格式不正确");
            _this.setState({
                captDisable: "true",
                phoneFormat:true
            })
        } else {
          if (time == null) {
            _this.setState({
                  captDisable: false,
                  phoneFormat: false
              })
          }
          callback();
        }
    } else {
        callback();
        _this.setState({
            captDisable: "true",
            phoneFormat: true
        })
    }
  }
  callbacktab=(value)=>{
    this.setState({tabkey:value,alertShow:''})
    this.props.form.resetFields()
  }
  //手机号码提交
  handleSubmitPhone = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(values)
      if (!err) {
           
           _LoginModule.setState({
            loading: true
          })

          setTimeout(function () {
            //登录
            $.ajax({
              url: Hcurl + "/HomePage/UserLoginByCode",
              type: "post",
              data: {
                linkPhone: values.phone,
                validCode: values.captcha,
                Explore:EventSet.myBrowser(),
                SystemName:EventSet.browserRedirect(),
              },
              async: false,
              success: function (res) {
                let userInfo = JSON.parse(res);
                
                _LoginModule.setState({
                  loading: false
                })

                if (userInfo.msg.indexOf("false") >= 0) {
                  //警告提示词
                  if (userInfo.msg.split("|")[1] != undefined) {
                    _LoginModule.setState({
                      messageWarn: userInfo.msg.split("|")[1]
                    })
                  }
                  


                  setTimeout(function () {
                    _LoginModule.setState({
                      alertShow: <Alert message={_LoginModule.state.messageWarn} type="error" showIcon closable onClose={_LoginModule.onClose} />
                    })
                  }, 50)

                } else {
                  if (values.remember) {
                    localStorage.setItem("username", values.userName)
                    localStorage.setItem("rememberUser", "true");
                  } else {
                    localStorage.removeItem("username")
                    localStorage.setItem("rememberUser", "false");
                  }
                  localStorage.setItem("userInfo", res);
                  var info=JSON.parse(res)['Info'];
                  sessionStorage.setItem('pwdInfo',info);
                  // EventSet.setCookie('userInfo',res)
                  $.ajax({
                    url: Hcurl + "/CompanyCore/GetSelectCompany",
                    type: "post",
                    data: {
                      UserCode: userInfo.CU_Code
                    },
                    headers: {
                      "token": userInfo.token
                    },
                    success: function (res) {
                      time = null
                      if (res != null) {
                        res = JSON.parse(res);
                      }
                      if(userInfo.Info=='1'){
                        if (res.length == 0 || res == null || res == undefined || res == "") {
                          history.push({ pathname: '/Content/Business/CompanyList', })
                        } else {
                          history.push({ pathname: '/Content/Home', })
                        }
                      }else if(userInfo.Info=='2'||userInfo.Info=='4'){
                        _LoginModule.onMessageSend()
                      }else if(userInfo.Info=='3'){
                        history.push({ pathname: '/Login/LoginMain/LoginInfo', })
                      }
                      
                    },
                    error: function () {
                        //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    }
                  })
                }
                
              },
              error: function () {
                  //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
              }
            })
          }, 100)
        }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div style={{ overflow: "hidden",padding:'40px'}}>
        {/* <div className="loginLogo">
          <img src={logo} alt="" />
        </div> */}
         <PasswordModal/>
        <div style={{ padding:'0px 40px 40px 40px' }}>
          <div style={{textAlign:'center',fontSize:'20px',lineHeight:'40px',color:'#028B7B'}}>商家人员登录</div>
          <Tabs defaultActiveKey={this.state.tabkey} onChange={this.callbacktab}>
            <TabPane tab="账户密码登录" key="1">
                <Form onSubmit={this.handleSubmit} className="login-form">
                {this.state.alertShow}
                <FormItem>
                  {getFieldDecorator('userName', {
                    rules: [{ required: this.state.tabkey=='1'?true:false, message: '请输入用户名!' }],
                  })(
                    <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} size="large" placeholder="请输入用户名" style={{ marginTop: "20px" }} maxLength="20" />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [{ required: this.state.tabkey=='1'?true:false, message: '请输入密码!' }],
                  })(
                    <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} size="large" type="password" placeholder="请输入密码" maxLength="20" />
                  )}
                </FormItem>
                <FormItem >
                      {getFieldDecorator('yzm', {
                          rules: [{ required: this.state.tabkey=='1'?true:false, message: '验证码不能为空!' }],
                      })(
                          <Input size="large" maxLength={4} placeholder="请输入验证码" style={{ width: '60%' }} id='VerificationCode' value={this.state.value} />
                          )}
                      <div style={{float:'right'}}>
                      <div onClick={() => this.onRefres()} style={{width:'40px',height:'40px',textAlign:'center',background:'#fafafa',border:'1px solid #d9d9d9',float:'right'}}><Icon style={{fontSize:'24px',marginTop: '6px',cursor: 'pointer'}} type="reload" /></div>
                          <img id="img"
                              style={{ width: '115px', height: 40, marginLeft: '25px', float:'right',border:'1px solid #d9d9d9',borderRight:'none'  }}
                              src={this.state.ImageSrc}  />
                          
                      </div>    
                      
                     
                  </FormItem>
                {/* <div id="captcha" style={{ position: "relative" }}></div> */}
                <FormItem>
                  {/* {getFieldDecorator('remember')(
                    <Checkbox checked={this.state.UserChecked} onChange={this.UserChange}>记住用户名</Checkbox>
                  )} */}
                  <a className="login-form-forgot" style={{ float: "right" }} onClick={this.forgetPassword}>忘记密码?</a>
                  <div style={{ margin: "10px 0" }}>
                    <Button type="primary" htmlType="submit" className="login-form-button" size="large" style={{ width: "100%", borderRadius: "20px" }} loading={this.state.loading}>
                      登录
                            </Button>
                  </div>
                  <div>还没有账号？<a onClick={this.register}>点击注册</a></div>
                  {/* <a style={{ float: 'right' }} onClick={this.operation}>使用说明</a> */}
                </FormItem>
              </Form>
            </TabPane>
            <TabPane tab="手机号登录" key="2">
                <Form onSubmit={this.handleSubmitPhone} className="login-form">
                {this.state.alertShow}
                <FormItem
                     
                    >
                        {getFieldDecorator('phone', {
                            rules: [{
                                required: this.state.tabkey=='2'?true:false, message: '请输入手机号码!'
                            }, {
                                validator: this.phoneInputTest,
                            }],
                        })(
                            <Input placeholder="请输入手机号码" size="large" maxLength="11" style={{ marginTop: "20px" }} />
                            )}
                    </FormItem>
                    <FormItem
                    
                    >
                        <Row gutter={8}>
                            <Col span={16}>
                                {getFieldDecorator('captcha', {
                                    rules: [
                                        {
                                            required: this.state.tabkey=='2'?true:false, message: '请输入验证码！'
                                        }, {
                                        validator: this.captchaTest,
                                    }],
                                })(
                                    <Input maxLength="6" placeholder="验证码" size="large" />
                                    )}
                            </Col>
                            <Col span={8}>
                                <Button size="large" onClick={this.getCaptcha} style={{ width: "125px",float:'right' }} disabled={this.state.captDisable}> { this.state.captcha }</Button>
                            </Col>
                        </Row>
                    </FormItem>
                    {/* <div id="captcha" style={{ position: "relative" }}></div> */}
                <FormItem>
                
                  <div style={{ margin: "20px 0" }}>
                    <Button type="primary" htmlType="submit" className="login-form-button" size="large" style={{ width: "100%", borderRadius: "20px" }} loading={this.state.loading}>
                      登录
                            </Button>
                  </div>
                  <div>还没有账号？<a onClick={this.register}>点击注册</a></div>
                  {/* <a style={{ float: 'right' }} onClick={this.operation}>使用说明</a> */}
                </FormItem>
                    </Form>
            </TabPane>
             
          </Tabs>
          
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(LoginModule);

class App extends Component {
  componentWillMount() {
  }
  componentDidMount() {
    // //执行滑动验证
    // EventSet.slide(window)
    // //滑动验证
    // window.jigsaw.init(document.getElementById('captcha'), function () { })
  }
  render() {
    return (
      <div className="LoginWrap userLogin">
        <div className="logoTitle"></div>
        <div className="LoginTitle">
          <div className="LoginInput">
            <WrappedNormalLoginForm />
          </div>
        </div>
      </div>
    );
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Login/LoginEntry/LoginEntry.js